import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Collapse, Form, FormGroup, Label, Row,} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    deleteErrorMsg,
    error,
    LIST,
    NO, NO_DATA_FOUND,
    YES,
} from "../../../components/i18n/i18n";
import {showToastCustom} from "../../../components/toast/customToast";
import {confirmAlert} from "react-confirm-alert";
import {utilHelper} from "../../../jwt/_helpers";
import {
    ButtonClean,
    ButtonSearch,
    ButtonTableFilter, GenericTableButton
} from "../../../components/buttons/buttonsActions";
import BootstrapTable from "react-bootstrap-table-next";
import {useForm} from "react-hook-form";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {productProvider} from "../../../providers/productProvider";
import {productPromotionService} from "../../../jwt/_services/promotions/productPromotionService";
import {productPriceService} from "../../../jwt/_services/promotions/productPriceService";
import ProductPriceElement from "../../../components/promotion/productPriceElement";
import {ProductPromotionPackageModal} from "../productPromotionPackage/productPromotionPackageModal";
import SelectGeneric from "../../../components/select/selectGeneric";
import {TT_COMPONENTS, TT_DELETE, TT_EDIT, TT_UPD_PRICES} from "../../../components/i18n/toolTips";
import {AssignPrice} from "../../../components/alert/assignPrice";

export const ProductPromotionList = forwardRef((props, ref) => {
    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [promotion] = useState(props.promotion);
    const [collapsed, setCollapsed] = useState(false);
    const [listItems, setListItems] = useState([]);

    const [showModal, setShowModal] = useState(true);
    const [productPromotion, setProductPromotion] = useState(false);
    const modalRef = useRef(null);

    const [productId, setProductId] = useState(null);

    useEffect(() => {
        setLoading(true);

        const dataRequest = {
            fbDataBase : { id: fbDataBaseId },
            onlyRegistered: true,
            item : {
                promotion: {id: promotion?.id}
            }
        }

        refreshDataList(dataRequest);
    }, []);

    const handleTableChange = () => {
        const dataRequest = {
            fbDataBase : { id: fbDataBaseId },
            onlyRegistered: true,
            item : {
                promotion: { id: promotion?.id },
            }
        }

        refreshDataList(dataRequest);
    };

    const setLoading = (loading) => {
        props.setLoading(loading)
    };

    const refreshDataList = (dataRequest) => {
        setLoading(true);
        setListItems([]);
        props.handleChilds([])

        productPromotionService.search(0, 1000, dataRequest)
            .then(result => {
                setListItems(result || []);
                props.handleChilds(result || [])
            })
            .catch(errorMessage => {
                setListItems([]);
                props.handleChilds([])
                showToastCustom(error, errorMessage);
            })
            .finally(() => {
                setLoading(false)
            });
    }

    useImperativeHandle(ref, () => ({
        refreshList() {
            const dataRequest = {
                fbDataBase : { id: fbDataBaseId },
                onlyRegistered: true,
                item : {
                    promotion: { id: promotion?.id },
                    product: { id: productId }
                }
            }

            refreshDataList(dataRequest);
        }
    }));

    // ----------------------------------------------
    //            SEARCH FILTERS FORM
    // ----------------------------------------------
    const {handleSubmit, reset} = useForm({});

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase : { id: fbDataBaseId },
            onlyRegistered: true,
            item : {
                promotion: { id: promotion?.id },
                product: { id: productId }
            }
        }

        refreshDataList(dataRequest);
    };

    const showFilters = () => setCollapsed(!collapsed);

    const cleanFields = () => {
        setLoading(true);
        reset();
        setProductId(null);

        const dataRequest = {
            fbDataBase : { id: fbDataBaseId },
            onlyRegistered: true,
            item : {
                promotion: { id: promotion?.id },
                product: { id: null }
            }
        }

        refreshDataList(dataRequest);
    }

    // ----------------------------------------------
    //            TABLE BUTTONS
    // ----------------------------------------------
    const editItem = (data) => {
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.setForm(true, itemToEdit);
    }

    const editMultiProducts = (data) => {
        //props.editMultiProducts(data)
        const _productPromotion = {
            PPId : data.PPId,
            promotion: {id: promotion?.id},
            product: {id: data.id}
        }

        setProductPromotion(_productPromotion );
        setShowModal(true);
        modalRef.current.showModal(_productPromotion);
    }

    const syncPrices = (data) => {
        setLoading(true);
        const dataRequest = {
            promotion: {id: promotion?.id},
            product: {id: data?.product?.id}
        }

        productPriceService.syncSingleProduccInPromotionPrices(dataRequest)
            .then(_ => {
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
    }

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        productPromotionService.deleteItem(data?.id, fbDataBaseId)
            .then(_ => {
                setLoading(false);

                const dataRequest = {
                    fbDataBase : { id: fbDataBaseId },
                    onlyRegistered: true,
                    item : {
                        promotion: { id: promotion?.id },
                        product: { id: null }
                    }
                }

                refreshDataList(dataRequest);

                if (utilHelper.hasAssociateRecords()) {
                    showToastCustom(error, deleteErrorMsg, true);
                    utilHelper.restartAssociateRecords();
                }
            });
    }

    const onPricesChange = () => {
        const dataRequest = {
            fbDataBase : { id: fbDataBaseId },
            onlyRegistered: true,
            item : {
                promotion: { id: promotion?.id },
                product: { id: productId }
            }
        }

        refreshDataList(dataRequest);
    }

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------
    const activeFormatter = (cell) => <ActiveFormatter active={cell}/>

    const confirmAssignPrice = item => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside:true,
        customUI: ({onClose}) => <AssignPrice
            item = { item }
            onClose = { onClose }
            promotion = { promotion }
            updateList={ onPricesChange }
        />
    });

    const actionsFormatter = (cell, row) => <>
        <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
        <GenericTableButton toolTip={TT_UPD_PRICES} icon={'fa-dollar-sign'} permission={'prices'} onClick={() => syncPrices(row)}/>
        <GenericTableButton toolTip={TT_COMPONENTS} icon={'fa-box-open'} permission={'edit'} onClick={() => editMultiProducts(row)}/>
        <GenericTableButton toolTip={TT_UPD_PRICES} icon={'fa fa-money'} permission={'prices'} onClick={() => confirmAssignPrice(row)}/>
        <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
    </>

    const expandRow = {
        renderer: row => <ProductPriceElement row={row}/>,
        showExpandColumn : true,
        expandByColumnOnly: true
    };

    const columns = [
        {
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'ppid',
        headerStyle: {width: '0px'},
        text: 'PPID',
        hidden: true
    }, {
        dataField: 'productName',
        text: 'Nombre'
    }, {
        dataField: 'productSivexId',
        text: 'Id Sivex',
        headerAlign: 'center',
        align: 'center',
    }, {
        dataField: 'productSivexCode',
        text: 'Codigo Sivex',
        headerAlign: 'center',
        align: 'center',
    }, {
        dataField: 'udnName',
        text: 'Landing Code',
        headerAlign: 'center',
        align: 'center',

    }, {
        dataField: 'status',
        text: "Activo",
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '80px'},
        formatter: activeFormatter
    }, {
        dataField: 'actions',
        isDummyField: true,
        text: 'Acción',
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '300px'},
        formatter: actionsFormatter
    }];

    return <>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                    <div className="float-right">
                        <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
                    </div>
                </CardTitle>
                <Collapse isOpen={collapsed}>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <CardBody className="">
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <Label>Producto</Label>
                                        <SelectGeneric
                                            initialValue={ productId }
                                            setExternalValue={ setProductId }
                                            provider = { productProvider }
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="8">
                                    <div className="float-right">
                                        <ButtonSearch/>
                                        <ButtonClean onClick={() => cleanFields()}/>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Form>
                </Collapse>
                <CardBody className="">
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listItems}
                        columns={columns}
                        expandRow={ expandRow }
                        noDataIndication={NO_DATA_FOUND}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
            {
                showModal &&
                <ProductPromotionPackageModal
                    ref={modalRef}
                    productPromotion={productPromotion}
                />
            }
        </>
});
